import type { NavSectionProps } from 'src/components/nav-section';

import { Chip } from '@mui/material';

import { paths } from 'src/routes/paths';

import { SvgColor } from 'src/components/svg-color';

// ----------------------------------------------------------------------

const icon = (name: string) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} />;

const ICONS = {
  job: icon('ic-job'),
  blog: icon('ic-blog'),
  chat: icon('ic-chat'),
  mail: icon('ic-mail'),
  user: icon('ic-user'),
  file: icon('ic-file'),
  lock: icon('ic-lock'),
  tour: icon('ic-tour'),
  order: icon('ic-order'),
  label: icon('ic-label'),
  blank: icon('ic-blank'),
  kanban: icon('ic-kanban'),
  folder: icon('ic-folder'),
  course: icon('ic-course'),
  banking: icon('ic-banking'),
  booking: icon('ic-booking'),
  invoice: icon('ic-invoice'),
  product: icon('ic-product'),
  calendar: icon('ic-calendar'),
  disabled: icon('ic-disabled'),
  external: icon('ic-external'),
  menuItem: icon('ic-menu-item'),
  analytics: icon('ic-analytics'),
  dashboard: icon('ic-dashboard'),
  parameter: icon('ic-parameter'),
  home: icon('ic-solar'),
  settings: icon('ic-settings'),
  gettingStarted: icon('ic-getting-started'),
};

// ----------------------------------------------------------------------

const comingSoonTag = () => (
    <Chip
      variant="soft"
      color="primary"
      size="small"
      label="Coming Soon"
    />
  )

const ALL_NAV_ITEMS = [
  {
    items: [
      {
        title: 'Getting Started',
        path: paths.gettingStarted.root,
        icon: ICONS.gettingStarted,
      },
      { title: 'Jobs', path: paths.jobs.root, icon: ICONS.job },
      { title: 'Candidates', path: paths.candidates.root, icon: ICONS.user },
      // { title: 'Agents', path: paths.agents.root, icon: ICONS.order },
      // { title: 'Matches', path: paths.matches.root, icon: ICONS.analytics },
    ],
  },
  {
    items: [
     // { title: 'Interviews', path: paths.interviews.root, icon: ICONS.calendar, disabled: true },
      { title: 'Reports', path: paths.reports.root, icon: ICONS.parameter, disabled: true, info: comingSoonTag() },
      { title: 'Automations', path: paths.automations.root, icon: ICONS.kanban, disabled: true, info: comingSoonTag() },
    ],
  },
  {
    items: [
      { title: 'Organization Settings', path: paths.orgSettings.root, icon: ICONS.settings },
    ],
  },
];

export function getNavData(
  hasOrganizationLogo: boolean,
  hasJobs: boolean,
  isAiInterviewsAvailable: boolean = true
): NavSectionProps['data'] {

  if (hasOrganizationLogo && hasJobs) {
    return ALL_NAV_ITEMS
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => item.title !== 'Getting Started'),
      }))
      .filter((group) => group.items.length > 0);
  }

  return ALL_NAV_ITEMS;
}
